<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new driver absence</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-driver-absence-form [driverAbsence]='this.driverAbsence'></app-driver-absence-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/drivers/absence'>Cancel</button>
    </form>
  </div>
</div>
